// extracted by mini-css-extract-plugin
export default {"buttons":"ButtonTable_buttons__Abojg","table":"ButtonTable_table__8hpDD","title":"ButtonTable_title__UdLxj"};